import { Spinner } from "@chakra-ui/react";

export const ComplianceQuestionsLoading = () => {
	return (
		<div
			className="flex items-center justify-center py-12"
			data-testid="compliance-questions-loading"
		>
			<Spinner size="lg" color="blue.500" />
		</div>
	);
};
